(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kiks-sticky-navbar"] && !Shopify.designMode) return;
  try {
    
  class KiksStickyNavbar extends HTMLElement {
    constructor() {
      super();

      this.navItems = this.querySelectorAll('[data-nav-item]');
      this.enableSticky = this.dataset.enableSticky === 'true';
      this.mainContent = document.getElementById('MainContent');
      this.sections = [];
      this.triggerPoint = Number.POSITIVE_INFINITY;
      this.atcZoneTop = Number.POSITIVE_INFINITY;
      this.atcZoneBottom = Number.POSITIVE_INFINITY;
      this.hasCrossedAtcZone = false;
      this.lastScrollTop = window.pageYOffset;
      this.scrollDirectionThreshold = 6;
      this.resetHysteresis = 40;
      this.ticking = false;

      this.handleResize = this.handleResize.bind(this);
      this.handleScroll = this.handleScroll.bind(this);

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init());
      } else {
        this.init();
      }
    }

    init() {
      this.initSections();
      this.updateTriggerPoint();
      this.setupEventListeners();
      this.checkActiveSection();

      if (!this.enableSticky) {
        this.classList.remove('is-sticky');
        return;
      }

      this.handleStickyBehavior();
      window.addEventListener('resize', this.handleResize);
      setTimeout(() => {
        this.initSections();
        this.updateTriggerPoint();
        this.checkActiveSection();
        this.handleStickyBehavior();
      }, 500);
    }

    initSections() {
      if (!this.mainContent) return;

      const allSections = Array.from(this.mainContent.querySelectorAll('.shopify-section, [id^="shopify-section"]'));
      const uniqueSections = allSections.filter((section) => {
        const parent = section.parentElement.closest('.shopify-section, [id^="shopify-section"]');
        return !parent || parent === section;
      });

      uniqueSections.forEach((section, index) => {
        section.setAttribute('data-nav-section-index', index + 1);
      });

      this.sections = uniqueSections;
    }

    getTriggerElement() {
      const scopedMain = this.mainContent || document;

      const mainProductForm = scopedMain.querySelector("form[id^='product-form-'][id*='---MainSection']");
      if (mainProductForm) {
        return mainProductForm;
      }

      return (
        scopedMain.querySelector('button[id^="product-buy-btn-"][id*="---MainSection"]') ||
        scopedMain.querySelector('button[id^="product-buy-btn-"]') ||
        scopedMain.querySelector('.product-form__btn')
      );
    }

    updateTriggerPoint() {
      const triggerElement = this.getTriggerElement();
      if (!triggerElement) {
        this.triggerPoint = Number.POSITIVE_INFINITY;
        this.atcZoneTop = Number.POSITIVE_INFINITY;
        this.atcZoneBottom = Number.POSITIVE_INFINITY;
        this.hasCrossedAtcZone = false;
        return;
      }

      const top = this.getAbsoluteOffsetTop(triggerElement);
      const height = Math.max(triggerElement.offsetHeight || 0, triggerElement.getBoundingClientRect().height || 0);
      const bottom = top + height;

      this.atcZoneTop = top;
      this.atcZoneBottom = bottom;
      this.triggerPoint = bottom;

      // Keep state coherent on reload/resize when already below ATC zone.
      if (window.pageYOffset >= this.atcZoneBottom) {
        this.hasCrossedAtcZone = true;
      }
    }

    setupEventListeners() {
      this.navItems.forEach((item) => {
        item.addEventListener('click', () => {
          const requestedIndex = parseInt(item.getAttribute('data-section-index'), 10);
          const targetSection = this.sections[requestedIndex - 1];
          if (!targetSection) return;

          const navbarHeight = this.classList.contains('is-sticky') ? this.offsetHeight : 0;
          const targetPosition = this.getAbsoluteOffsetTop(targetSection) - navbarHeight;

          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });

          this.setActiveItem(item, { smooth: true, forceCenter: true });
        });
      });

      window.addEventListener('scroll', this.handleScroll, { passive: true });
    }

    handleScroll() {
      if (this.ticking) return;

      window.requestAnimationFrame(() => {
        this.checkActiveSection();
        if (this.enableSticky) {
          this.handleStickyBehavior();
        }
        this.ticking = false;
      });

      this.ticking = true;
    }

    handleStickyBehavior() {
      const currentScroll = window.pageYOffset;
      const delta = currentScroll - this.lastScrollTop;

      let direction = 'none';
      if (delta > this.scrollDirectionThreshold) {
        direction = 'down';
      } else if (delta < -this.scrollDirectionThreshold) {
        direction = 'up';
      }

      const hasValidTrigger = Number.isFinite(this.atcZoneTop) && Number.isFinite(this.atcZoneBottom);
      if (!hasValidTrigger) {
        this.classList.remove('is-sticky');
        this.hasCrossedAtcZone = false;
        this.lastScrollTop = currentScroll;
        return;
      }

      // Reset latched state when user scrolls back above the ATC zone.
      if (currentScroll <= this.atcZoneTop - this.resetHysteresis) {
        this.hasCrossedAtcZone = false;
        this.classList.remove('is-sticky');
        this.lastScrollTop = currentScroll;
        return;
      }

      // Latch only when scrolling down and crossing the ATC zone bottom line.
      if (!this.hasCrossedAtcZone && direction === 'down' && currentScroll >= this.atcZoneBottom) {
        this.hasCrossedAtcZone = true;
      }

      if (!this.hasCrossedAtcZone) {
        this.classList.remove('is-sticky');
        this.lastScrollTop = currentScroll;
        return;
      }

      if (direction === 'up') {
        this.classList.remove('is-sticky');
      } else if (direction === 'down') {
        this.classList.add('is-sticky');
      }

      this.lastScrollTop = currentScroll;
    }

    getAbsoluteOffsetTop(element) {
      let offsetTop = 0;
      while (element) {
        offsetTop += element.offsetTop;
        element = element.offsetParent;
      }
      return offsetTop;
    }

    handleResize() {
      window.requestAnimationFrame(() => {
        this.initSections();
        this.updateTriggerPoint();
        this.checkActiveSection();
        this.handleStickyBehavior();
      });
    }

    checkActiveSection() {
      if (!this.sections.length) return;

      const navbarHeight = this.classList.contains('is-sticky') ? this.offsetHeight : 0;
      const totalOffset = navbarHeight;
      const viewportHeight = window.innerHeight;
      const viewportBottom = window.scrollY + viewportHeight;

      const visibilityData = this.sections.map((section, index) => {
        const rect = section.getBoundingClientRect();
        const sectionTop = window.scrollY + rect.top;
        const sectionHeight = rect.height;
        const sectionBottom = sectionTop + sectionHeight;

        const visibleTop = Math.max(sectionTop, window.scrollY + totalOffset);
        const visibleBottom = Math.min(sectionBottom, viewportBottom);
        const visibleHeight = Math.max(0, visibleBottom - visibleTop);
        const visibilityRatio = visibleHeight / sectionHeight;

        return {
          index,
          section,
          visibilityRatio,
          isInView: visibilityRatio > 0
        };
      });

      let mostVisibleSection = null;
      let maxVisibility = 0;

      visibilityData.forEach((data) => {
        if (data.isInView && data.visibilityRatio > maxVisibility) {
          maxVisibility = data.visibilityRatio;
          mostVisibleSection = data.section;
        }
      });

      if (window.scrollY <= 10) {
        mostVisibleSection = this.sections[0];
      }

      if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 10) {
        mostVisibleSection = this.sections[this.sections.length - 1];
      }

      if (!mostVisibleSection) return;

      const sectionIndex = this.sections.indexOf(mostVisibleSection) + 1;
      const activeNavItem = Array.from(this.navItems).find(
        (item) => parseInt(item.getAttribute('data-section-index'), 10) === sectionIndex
      );

      if (activeNavItem) {
        this.setActiveItem(activeNavItem, { smooth: false, forceCenter: false });
      }
    }

    setActiveItem(activeItem, options = {}) {
      if (!activeItem) return;
      const { smooth = false, forceCenter = false } = options;

      this.navItems.forEach((item) => {
        if (item !== activeItem && item.classList.contains('is-active')) {
          item.classList.remove('is-active');
        }
      });

      if (activeItem.classList.contains('is-active')) return;

      activeItem.classList.add('is-active');
      const navbarContainer = this.querySelector('.kiks-sticky-navbar__items');
      if (!navbarContainer) return;

      const containerWidth = navbarContainer.offsetWidth;
      const itemWidth = activeItem.offsetWidth;
      const itemLeft = activeItem.offsetLeft;
      const currentScrollLeft = navbarContainer.scrollLeft;
      const itemVisibleLeft = itemLeft - currentScrollLeft;
      const itemVisibleRight = itemVisibleLeft + itemWidth;
      const isItemFullyVisible = itemVisibleLeft >= 0 && itemVisibleRight <= containerWidth;
      if (!forceCenter && isItemFullyVisible) return;
      const scrollLeft = itemLeft - containerWidth / 2 + itemWidth / 2;

      navbarContainer.scrollTo({
        left: scrollLeft,
        behavior: smooth ? 'smooth' : 'auto'
      });
    }
  }

  if (!customElements.get('kiks-sticky-navbar')) {
    customElements.define('kiks-sticky-navbar', KiksStickyNavbar);
  }

  } catch(e) { console.error(e); }
})();
})();
